export interface WhatsAppPhoneNumber {
  whatsAppId: string;
  name: string;
  displayedNumber: string;
  standardizedPhoneNumber: string;
  status: WhatsAppPhoneNumberStatus;
}

export enum WhatsAppPhoneNumberStatus {
  VALID = 'VALID',
  DISPLAY_NAME_VALIDATION_REQUIRED = 'DISPLAY_NAME_VALIDATION_REQUIRED',
  REGISTRATION_REQUIRED = 'REGISTRATION_REQUIRED',
  INVALID = 'INVALID'
}

export interface WhatsAppAccount {
  _id: string;
  user: string;
  whatsAppId: string;
  name: string;
  phoneNumbers: WhatsAppPhoneNumber[];
  accessRevokedDate?: number;
}

export interface DeletePhoneNumberDto {
  accountId: string;
  phoneNumberWhatsAppId: string;
}

export interface ConnectWhatsAppAccountDto {
  code: string;
  whatsAppAccountId: string;
  whatsAppPhoneNumberId: string;
}
